import { useEffect } from 'react';
import { ResultsMain } from '@/components';
import { useFilterStore, useAvailabilityStore } from '@/store';
import { calculateAvailability } from '@/utils';

export const CourseResults = () => {
  const { activeFilters, currentFilterSet } = useFilterStore();
  const { actions: availabilityActions } = useAvailabilityStore();

  useEffect(() => {
    availabilityActions.setActiveAvailability(calculateAvailability(activeFilters, currentFilterSet));
  }, [activeFilters, currentFilterSet, availabilityActions]);

  return <ResultsMain showRegion={true} />;
};
